import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that manages a klaviyo bis drawer.
 *
 * @extends {Component}
 */
class StickyProductFormComponent extends Component {
  requiredRefs = ['container', 'content'];

  #intersectionObserver = new IntersectionObserver(([entry]) => {
    if (!entry) return;

    this.refs.container.classList[entry.isIntersecting ? 'remove' : 'add']('visible')
  }, {
    root: null,
    threshold: 0
  });

  #productId = this.dataset.productId;
  #mainForm = document.querySelector('.product-details .shopify-product-form');

  #resizeObserver = new ResizeObserver(([entry]) => {
    if (!entry) return;

    const { height } = entry.target.getBoundingClientRect();

    document.body.style.paddingBlockEnd = `${height}px`
  });

  connectedCallback() {
    super.connectedCallback();

    this.#resizeObserver.observe(this.refs.container);

    this.variantId = this.dataset.variantId
    document.addEventListener(ThemeEvents.variantUpdate, this.onVariantChange.bind(this))
    this.querySelector('[name="quantity"]')?.addEventListener(ThemeEvents.quantitySelectorUpdate, this.onQuantityChange.bind(this))

    if (this.#mainForm) {
      this.#intersectionObserver.observe(this.#mainForm);
      this.#mainForm?.querySelector('[name="quantity"]')?.addEventListener(ThemeEvents.quantitySelectorUpdate, this.onMainQuantityChange.bind(this))
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver.disconnect();
    document.removeEventListener(ThemeEvents.variantUpdate, this.onVariantChange)
  }

  onVariantChange(e) {
    const { resource, data } = e.detail

    if (data.productId !== this.#productId) return;

    this.querySelector('[name="id"]').value = resource.id
  }

  onMainQuantityChange(e) {
    const { quantity } = e.detail

    this.querySelector('quantity-selector-component').setValue(quantity)
  }

  onQuantityChange(e) {
    const { quantity } = e.detail

    this.#mainForm.querySelector('quantity-selector-component').setValue(quantity)
  }

  submitForm () {
    const mainFormButton = document.querySelector('.product-details .shopify-product-form [type="submit"]')
    mainFormButton.click()
  }

  expandForm() {
    this.dataset.expanded = 'true'
  }

  closeForm() {
    this.dataset.expanded = 'false'
  }
}

if (!customElements.get('sticky-product-form-component')) {
  customElements.define('sticky-product-form-component', StickyProductFormComponent);
}
